export const domainContains = (keyword: string): boolean => {
    return window.location.hostname.includes(keyword);
};
